export const WAS = "http://localhost:8080/";



export const ShoppingProcessType = {
    CART: 1,
    ORDER: 2,
    ORDER_COMPLETE: 3
}